@if (showCondition) {
  <button mat-button
    class="compact-history-button"
    [matTooltip]="tooltip"
    [disabled]="disabled"
    (click)="onHistoryClick()"
    >
    <mat-icon>history</mat-icon>
    <span>{{ buttonText }}</span>
  </button>
}